import { inject } from '@angular/core';
import { CanActivateFn, UrlTree, Router } from '@angular/router';
import { AuthenticationService } from '@core/services/authentication/authentication.service';

export const LoginGuard: CanActivateFn = (): boolean | UrlTree => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return !authService.isLoggedIn()
    ? true
    : router.createUrlTree(['/transaction/list']);
};
